import {NgModule} from '@angular/core';
import {SharedModule} from "../../common/shared.module";
import {RagComponent} from "./rag.component";
import {RagAddDialogComponent} from "./rag-add-dialog.component";
import {RagEditDialogComponent} from "./rag-edit-dialog.component";
import {UpdateTutorialsDialogComponent} from "./update-tutorials-dialog.component";
import {GptResponseDialogComponent} from "./gpt-response-dialog.component";

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        RagComponent,
        RagAddDialogComponent,
        RagEditDialogComponent,
        UpdateTutorialsDialogComponent,
        GptResponseDialogComponent
    ],
    exports: [],
    providers: []
})
export class RagModule {
}